import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=21e74049&scoped=true"
import script from "./questionnaire.vue?vue&type=script&lang=js"
export * from "./questionnaire.vue?vue&type=script&lang=js"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=21e74049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e74049",
  null
  
)

export default component.exports